<template>
  <div class="payment-country-selector" :class="{ wrongCountry: wrongCountry }">
    <div class="form-group">
      <label>{{ $t("placeholder.payment_country_selector") }}</label>
      <div class="input-group">
        <select
          required="required"
          :placeholder="$t('placeholder.payment_country_selector')"
          class="form-control"
          v-model="country"
          :disabled="countries.loading"
          @change="updateCountry"
        >
          <template v-if="countries.data">
            <option
              v-for="country in countries.data"
              :key="country.id"
              :value="country.id"
              :code="country.code"
            >
              {{ country.name }}
            </option>
          </template>
          <template v-else>
            <option selected="selected" disabled="disabled" :value="null">
              <template v-if="countries.loading">
                {{ $t("loading") }}
              </template>
              <template v-if="countries.error">
                {{ $t("error") }}
              </template>
            </option>
          </template>
        </select>
      </div>
      <p v-if="wrongCountry" class="error-message">
        {{ $t("validations.required", { field: $t("fields.country") }) }}
      </p>
    </div>
  </div>
</template>

<script>
import Spinner from "../Spinner";
import resources from "../../resources";

export default {
  mounted() {
    this.loadCountries();
    this.country = +this.defaultCountry;
  },
  components: {
    Spinner,
  },
  props: {
    defaultCountry: {
      required: true,
    },
  },
  data() {
    return {
      country: null,
      countries: {
        data: null,
        loading: false,
        error: false,
      },
      wrongCountry: false,
    };
  },
  methods: {
    loadCountries() {
      this.countries.data = null;
      this.countries.loading = true;

      //PANCHO VILLA WARNING
      //HAY QUE UNIFICAR ESTO PARA QUE NO SE LLAME 2 VECES AL PEDO!!
      resources.countries
        .index({ per_page: 9999, order_by: ["name"], include: ["is_current"] })
        .then((resp) => {
          this.countries.data = resp.data.data;
          this.countries.loading = false;
          this.countries.error = false;

          // If defaultCountry is set, find it in the list
          if (this.defaultCountry) {
            const foundCountry = this.countries.data.find(
              (c) => c.id === +this.defaultCountry
            );
            if (foundCountry) {
              this.countryCode = foundCountry.code;
              this.$emit("paymentCountryUpdated", {
                countryId: foundCountry.id,
                countryCode: this.countryCode,
              });
            }
          }
        })
        .catch((err) => {
          this.countries.loading = false;
          this.countries.error = true;
        });
    },
    updateCountry(event) {
      this.countryCode =
        event.target.options[event.target.selectedIndex].getAttribute("code");
      this.country = +event.target.value;
    },
    checkCountry() {
      if (!this.countries || !this.countries.data) return;

      let v = !!this.countries.data.find((c) => c.id === this.country);
      this.wrongCountry = !v;
      return v;
    },
  },
  watch: {
    country(newValue, oldValue) {
      if (oldValue === newValue || !newValue) return;
      this.$emit("paymentCountryUpdated", {
        countryId: newValue,
        countryCode: this.countryCode,
      });

      this.checkCountry();
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/variables";
@import "../../styles/classes";

.payment-country-selector {
  margin: 30px;
  padding: 30px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
  min-width: 250px;
  text-align: center;
}

.result-message {
  text-align: center;
}

.btn.submit {
  @extend %fresh-btn;
  font-size: 2em;
}

.wrongCountry {
  select {
    border: 1px solid var(--pallete_error_color);
  }

  label {
    color: var(--pallete_error_color);
  }
}
</style>
